module.exports = __webpack_public_path__ + "static/reaccion-4bf7cf5fc8e684fe9d4f2deafe7aecef.png";